import { render } from "./OrderDiscount.vue?vue&type=template&id=443a6928&scoped=true"
import script from "./OrderDiscount.vue?vue&type=script&lang=js"
export * from "./OrderDiscount.vue?vue&type=script&lang=js"

import "./OrderDiscount.vue?vue&type=style&index=0&id=443a6928&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443a6928"]])

export default __exports__